import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translations
const resources = {
  en: {
    translation: {
      // Add your English translations here
      'Create Account': 'Register',
      'Family Name': 'Last Name',
      'Given Name': 'First Name',
      'Enter your Family Name': 'Enter your last name',
      'Enter your Given Name': 'Enter your first name',
      "Welcome": "Welcome",
      "Sign Out": "Logout",
      "Login": "Login",
      "Hi": "Hi",
      "About Us": "About Us",
      "Contact Us": "Contact Us",
      "Location": "Location",
      "Hours": "Hours",
      "Services": "Services",
      "Gallery": "Gallery",
      "Home": "Home",
      "My Account": "My Account",
      "Edit Site": "Edit Site",
      "View Customers": "View Customers",
      "View Layaways": "View Layaways",
      "New": "New",
      "Repair": "Repair",
      "Sale": "Sale",
      "Today's Sales": "Today's Sales",
      "My": "My",
      "Layaways": "Layaways",
      "Purchases": "Purchases",
      "Preferences": "Preferences",
      "Transactions": "Transactions",
      "Recent Transactions": "Recent Transactions",
      "Edit Public Website": "Edit Public Website",
      "MONDAY": "Monday",
      "TUESDAY": "Tuesday",
      "WEDNESDAY": "Wednesday",
      "THURSDAY": "Thursday",
      "FRIDAY": "Friday",
      "SATURDAY": "Saturday",
      "SUNDAY": "Sunday",
      // Layaway wizard
      "Layaway Contract": "Layaway Contract",
      "Step": "Step",
      "Terms": "Terms",
      "Payments": "Payments",
      "Contact": "Contact",
      "Review": "Review",
      "Signature": "Signature",
      "Layaway Duration & Exchange Policy": "Layaway Duration & Exchange Policy",
      "Set how long the customer has to pay off the item, and the exchange grace period after the maturity date.": "Set how long the customer has to pay off the item, and the exchange grace period after the maturity date.",
      "Layaway Duration": "Layaway Duration",
      "Maturity Date": "Maturity Date",
      "Calculated automatically from today + duration. Adjust if needed.": "Calculated automatically from today + duration. Adjust if needed.",
      "Exchange Grace Period (days after maturity)": "Exchange Grace Period (days after maturity)",
      "Days after the maturity date during which the customer may exchange (not refund) the merchandise.": "Days after the maturity date during which the customer may exchange (not refund) the merchandise.",
      "Payment Details": "Payment Details",
      "Transaction total": "Transaction total",
      "Deposit Amount (paid today)": "Deposit Amount (paid today)",
      "Remaining balance after deposit": "Remaining balance after deposit",
      "Payment Plan": "Payment Plan",
      "Installment Amount (per payment)": "Installment Amount (per payment)",
      "Contact Confirmation": "Contact Confirmation",
      "Verify the customer's phone number. An SMS will be sent with a link to their contract.": "Verify the customer's phone number. An SMS will be sent with a link to their contract.",
      "Customer Phone (E.164 format, e.g. +18635551234)": "Customer Phone (E.164 format, e.g. +18635551234)",
      "Must include country code. Leave blank to skip SMS.": "Must include country code. Leave blank to skip SMS.",
      "The customer will receive a text message with a secure link to download the signed contract.": "The customer will receive a text message with a secure link to download the signed contract.",
      "Contract Review": "Contract Review",
      "Please review all details before the customer signs.": "Please review all details before the customer signs.",
      "Ticket #": "Ticket #",
      "Deposit": "Deposit",
      "Balance": "Balance",
      "Duration": "Duration",
      "days": "days",
      "Installment": "Installment",
      "Exchange Period": "Exchange Period",
      "SMS to": "SMS to",
      "(skipped)": "(skipped)",
      "Once submitted, the contract is locked and cannot be edited. Make sure all details are correct.": "Once submitted, the contract is locked and cannot be edited. Make sure all details are correct.",
      "Customer Signature": "Customer Signature",
      "Ask the customer to sign below using a mouse, stylus, or finger.": "Ask the customer to sign below using a mouse, stylus, or finger.",
      "Clear Signature": "Clear Signature",
      "After signing, clicking \"Generate Contract\" will create a locked PDF, upload it to secure storage, and send an SMS to the customer.": "After signing, clicking \"Generate Contract\" will create a locked PDF, upload it to secure storage, and send an SMS to the customer.",
      "Please provide a signature before submitting.": "Please provide a signature before submitting.",
      "Generating…": "Generating…",
      "Generate Contract": "Generate Contract",
      "Layaway Active": "Layaway Active",
      "Download Contract": "Download Contract",
      "Loading…": "Loading…",
      "Layaway Option": "Layaway Option",
      "Set Up Layaway Contract": "Set Up Layaway Contract",
      "Failed to generate contract": "Failed to generate contract",
      "Failed to download contract": "Failed to download contract"
    }
  },
  es: {
    translation: {
      'Create Account': 'Crear Cuenta',
      'Family Name': 'Apellido',
      'Given Name': 'Nombre',
      'Enter your Family Name': 'Ingrese su apellido',
      'Enter your Given Name': 'Ingrese su nombre',
      'Enter your Phone Number': 'Ingrese su número telefónico',
      'Phone Number': 'Número Telefónico',
      'Sign In': 'Iniciar Sesión',
      'Password': 'Contraseña',
      // Add your Spanish translations here
      "Welcome": "Bienvenido",
      "Sign Out": "Cerrar sesión",
      "Login": "Iniciar sesión",
      "Hi": "Hola",
      "About Us": "Sobre nosotros",
      "Contact Us": "Contáctenos",
      "Location": "Ubicación",
      "Hours": "Horario",
      "Services": "Servicios",
      "Gallery": "Galería",
      "Home": "Inicio",
      "My Account": "Mi cuenta",
      "Edit Site": "Editar sitio",
      "View Customers": "Ver clientes",
      "View Layaways": "Ver apartados",
      "New": "Nuevo",
      "Repair": "Reparación",
      "Repairs": "Reparaciónes",
      "Customers": "Clientes",
      "New Sale": "Nueva Venta",
      "Sale": "Venta",
      "Today's Sales": "Ventas de hoy",
      "My": "Mis",
      "Layaways": "Apartados",
      "Purchases": "Compras",
      "Preferences": "Preferencias",
      "Transactions": "Transacciones",
      "Recent Transactions": "Transacciones recientes",
      "Edit Public Website": "Editar sitio web público",
      "Public Website": "Pagina Web Pública",
      "Record Payment": "Tomar Pago de Apartado",
      "Repair Queue": "Lista de reparaciónes de Hoy",
      "Completed Repairs": "Reparaciónes Completos",
      "Customers": "Clientes",
      "Create Repair Job": "Crear trabajo de reparación",
      //InstallPromptTranslation:
      "Install Our App": "Instale nuestro app",
      "To use this app, you need to add it to your home screen": "Para usar esta aplicación, debes agregarla a tu pantalla de inicio",
      "Open Safari and visit our website": "Abra Safari y visite nuestro sitio web",
      "Tap the": "Toque en el",
      "icon at the bottom of the screen": "icono en la parte inferior de la pantalla",
      "Scroll down and tap": "Desplácese hacia abajo y toque",
      "Tap": "Toque",
      "Add": "Agregar",
      "on the top-right corner": "en la esquina superior derecha",

      "Add to Home Screen": "Agregar a Inicio",
      "Once added, please open the app from your home screen to continue using it": "Ya agregada, abra la aplicación desde su pantalla de inicio para continuar usándola",
      ///Static Home Page
      "Business hours are in device time":"El horario comercial se expresa en tiempo del dispositivo.",
      "Current Status": "Estado del negocio",
      "Open": "Abierto",
      "Openning Soon": "Abriendo Pronto",
      "Closed": "Cerrado",
      "Closing Soon": "Cerrando pronto",
      "MONDAY": "Lunes",
      "TUESDAY": "Martes",
      "WEDNESDAY": "Miercoles",
      "THURSDAY": "Jueves",
      "FRIDAY": "Viernes",
      "SATURDAY": "Sabado",
      "SUNDAY": "Domingo",
      //Hours Editor
      "Date": "Fecha",
      "Day": "Dia",
      "Actions": "Acciones",
      "Action": "Accion",
      "Special Hours": "Horario Especiales",
      "Add Special Hour": "Agregar Horario Especial",
      "Edit": "Modificar",
      "Delete": "Borrar",
      "Add Special Hours": "Agregar horas especiales",
      "Save": "Guardar",
      //Edit Contact and About Us:
      "Edit About Us and Contact Us": "Editar Acerca de nosotros y Contáctenos",
      "Close": "Cerrar",
      "Save Changes": "Guardar Cambios",
      "Edit Business Hours": "Editar Horario Comercial",
      "Edit Services": "Modificar Servicios",
      "Service Name": "Nombre de Servicio",
      "Service Description": "Description de Servicio",
      "Add Service": "Agregar Servicio",
      "Save": "Guardar",
      "Upload": "Subir",
      //Image Uploading
      "Next": "Siguente",
      "Prev": "Atras",
      "Loading": "Cargando",
      "Upload New Image": "Subir Nueva Imagen",
      "Description": "Descripción",
      "Tag": "Etiqueta De Imagen",
      "Add Tag": "Agregar otra etiqueta",
      "Item Number": "Número de artículo",
      //Special Hours
      "Open Time": "Hora de apertura",
      "Close Time": "Hora de cierre",
      //Customer Management Screens
      "Phone": "Teléfono",
      "Phone Number": "Número de teléfono",
      "Account Name": "Nombre de la cuenta",
      "Clear": "Borrar",
      "Enter search term": "Ingrese el término de búsqueda",
      "Customer Search": "Búsqueda de clientes",
      "New Account": "Nueva Cuenta",
      "Create Account": "Crear Cuenta",
      "New Business Account": "Nueva Cuenta de Negocio",
      "New Customer Account": "Nueva Cuenta de Cliente",
      "Business Profile": "Perfil de Negocio",
      "Business Name": "Nombre del Negocio",
      "First Name": "Nombre",
      "Last Name": "Apellido",
      "Business Phone": "Teléfono del Negocio",
      "Phone": "Teléfono",
      "Please enter a valid phone number.": "Por favor, ingrese un número de teléfono válido.",
      "Enrolled in Promotional Emails": "Inscrito en Correos Electrónicos Promocionales",
      "Business Email": "Correo Electrónico del Negocio",
      "Email": "Correo Electrónico",
      "Please enter a valid email address.": "Por favor, ingrese una dirección de correo electrónico válida.",
      "Create": "Crear",
      "Creating Account": "Creando Cuenta",
      "Cancel": "Cancelar",
      "Account Created": "Cuenta Creada",
      "Go to customer profile": "Ir al perfil del cliente",
      "Copy Customer ID": "Copiar ID del Cliente",
      "Customer ID copied to clipboard!": "¡ID del Cliente copiado al portapapeles!",
      //Customer Details Page Translation:
      "Account Name":"Nombre de Cuenta",
      "Layaway Contracts":"Contratos de Apartados",
      "Created on":" Fecha de Creacion",
      "Account Type":"Tipo de Cuenta",
      "Customer":"Cliente",
      "Business":"Negocio",
      "Email Promotions":"Promociones por Coreo Electronico",
      "Total Spend":"Gasto Total",
      "Total Savings":"Ahorros Total",
      "Reset Password":"Restablecer Contraseña",
      "Transaction Date":"Fecha de Transacción",
      "Transaction #": "Numero de Transacción",
      "Employee": "Empleado",
      "Total Items":"Numero de Articulos",
      "Balance Due": "Saldo Adeudado",
      "Repair Status": "Estado de Reparacion",
      "Completion Date":"Fecha de Terminacion",
      "Contract Start Date":"Fecha de inicio del contrato",
      "Time Remaining to Pay":"Tiempo Restante para Pagar",
      "Paid Full Date":"Fecha completa pagada",
      "Getting Account Information":"Obteniendo información de la cuenta",
      "Are you sure you want to reset the password for this customer?":"¿Está seguro de que desea restablecer la contraseña de este cliente?",
      // Layaway wizard — Spanish
      "Layaway Contract": "Contrato de Apartado",
      "Step": "Paso",
      "Terms": "Términos",
      "Payments": "Pagos",
      "Contact": "Contacto",
      "Review": "Revisión",
      "Signature": "Firma",
      "Layaway Duration & Exchange Policy": "Duración del Apartado y Política de Cambio",
      "Set how long the customer has to pay off the item, and the exchange grace period after the maturity date.": "Establezca cuánto tiempo tiene el cliente para pagar el artículo y el período de gracia para cambios después del vencimiento.",
      "Layaway Duration": "Duración del Apartado",
      "Maturity Date": "Fecha de Vencimiento",
      "Calculated automatically from today + duration. Adjust if needed.": "Se calcula automáticamente desde hoy + duración. Ajuste si es necesario.",
      "Exchange Grace Period (days after maturity)": "Período de Gracia para Cambio (días después del vencimiento)",
      "Days after the maturity date during which the customer may exchange (not refund) the merchandise.": "Días después del vencimiento en los que el cliente puede cambiar (no reembolsar) la mercancía.",
      "Payment Details": "Detalles de Pago",
      "Transaction total": "Total de la transacción",
      "Deposit Amount (paid today)": "Monto del Depósito (pagado hoy)",
      "Remaining balance after deposit": "Saldo restante después del depósito",
      "Payment Plan": "Plan de Pago",
      "Installment Amount (per payment)": "Cuota (por pago)",
      "Contact Confirmation": "Confirmación de Contacto",
      "Verify the customer's phone number. An SMS will be sent with a link to their contract.": "Verifique el número de teléfono del cliente. Se enviará un SMS con un enlace al contrato.",
      "Customer Phone (E.164 format, e.g. +18635551234)": "Teléfono del Cliente (formato E.164, ej. +18635551234)",
      "Must include country code. Leave blank to skip SMS.": "Debe incluir el código de país. Deje en blanco para omitir el SMS.",
      "The customer will receive a text message with a secure link to download the signed contract.": "El cliente recibirá un mensaje de texto con un enlace seguro para descargar el contrato firmado.",
      "Contract Review": "Revisión del Contrato",
      "Please review all details before the customer signs.": "Revise todos los detalles antes de que el cliente firme.",
      "Ticket #": "Ticket #",
      "Deposit": "Depósito",
      "Balance": "Saldo",
      "Duration": "Duración",
      "days": "días",
      "Installment": "Cuota",
      "Exchange Period": "Período de Cambio",
      "SMS to": "SMS a",
      "(skipped)": "(omitido)",
      "Once submitted, the contract is locked and cannot be edited. Make sure all details are correct.": "Una vez enviado, el contrato queda bloqueado y no puede modificarse. Asegúrese de que todos los detalles sean correctos.",
      "Customer Signature": "Firma del Cliente",
      "Ask the customer to sign below using a mouse, stylus, or finger.": "Pida al cliente que firme abajo con el mouse, lápiz digital o dedo.",
      "Clear Signature": "Borrar Firma",
      "After signing, clicking \"Generate Contract\" will create a locked PDF, upload it to secure storage, and send an SMS to the customer.": "Al firmar y hacer clic en \"Generar Contrato\", se creará un PDF bloqueado, se subirá al almacenamiento seguro y se enviará un SMS al cliente.",
      "Please provide a signature before submitting.": "Por favor proporcione una firma antes de enviar.",
      "Generating…": "Generando…",
      "Generate Contract": "Generar Contrato",
      "Layaway Active": "Apartado Activo",
      "Download Contract": "Descargar Contrato",
      "Loading…": "Cargando…",
      "Layaway Option": "Opción de Apartado",
      "Set Up Layaway Contract": "Configurar Contrato de Apartado",
      "Failed to generate contract": "Error al generar el contrato",
      "Failed to download contract": "Error al descargar el contrato"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: navigator.language.split('-')[0], // Detect the language from the browser
    fallbackLng: 'en', // Use English if detected language is not available
    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

export default i18n;
